import { E_VARIABLE_SURFACE } from "../types/design-editor";
import type { TVariableItems } from "../types/design-editor";
import type { ILoadedData, IRawSurfacesData } from "../types/table.types";
import stripHtml from "./strip-html";


export function InnerVdpDataFormatter(options: {
  vdpDataWithSurface: TVariableItems,
  revers?: boolean,
  useOriginalValue?: boolean,
}) {
  const { vdpDataWithSurface, revers, useOriginalValue } = options;

  let vdpData;

  if (Array.isArray(vdpDataWithSurface)) {
    vdpData = Object.entries({ [E_VARIABLE_SURFACE.DEFAULT]: vdpDataWithSurface });
  } else {
    vdpData = Object.entries(vdpDataWithSurface);
  }
  
  const surfaces = vdpData.map(([_, surfaceData]) => {
    let i = 0;
    const columns = (() => {
      if (Array.isArray(surfaceData[0])) {
        return (surfaceData as { name: string, type: string, value: string }[][])[0].map((data) => data.name);
      } else {
        return (surfaceData as { name: string, type: string, value: string }[]).map((data) => data.name);
      }
    })();
    const columnsTypes: Record<string, any> = {};
    const rows: any[] = [{}];
    if (Array.isArray(surfaceData[0])) {
      (surfaceData as { name: string, type: string, value: string }[][]).map((sur) => {
        rows[i] ??= {};
        sur.forEach((data) => {
          if (useOriginalValue) {
            rows[i][data.name] = stripHtml(data.value);
          } else {
            rows[i][data.name] = '';
          }
          columnsTypes[data.name] = data.type;
        });
        i++;
      });
    } else {
      (surfaceData as { name: string, type: string, value: string }[]).map((data) => {
        if (!rows[0]) {
          rows[0] = {};
        }
        if (useOriginalValue) {
          rows[0][data.name] = stripHtml(data.value);
        } else {
          rows[0][data.name] = '';
        }
        columnsTypes[data.name] = data.type;
        i++;
      });
    }
    return {
      columns,
      rows,
      columnsTypes,
    };
  });
  // TODO: check unique format columns and columnsTypes for multiple surfaces
  const dataset: ILoadedData = {
    columns: [],
    rows: [],
  };
  const surfacesData: IRawSurfacesData = {
    surfaces: vdpData.map(([surfaceName, _], index) => ({surfaceName, index})),
    columnsTypes: [{}],
  };
  surfaces.forEach((surface) => {
    dataset.columns = [
      ...dataset.columns,
      ...surface.columns,
    ];
    dataset.rows = [
      ...dataset.rows,
      ...surface.rows,
    ];
    surfacesData.columnsTypes[0] = Object.assign({}, surfacesData.columnsTypes[0], surface.columnsTypes);
  });
  dataset.columns = Array.from(new Set(dataset.columns).values());

  if (revers) {
    dataset.columns = dataset.columns.reverse();
  } 

  return {
    datasets: [dataset],
    surfacesData,
  };
}